import * as _animate from './animate';

export {
  createArrayIntentType,
  createIntentType,
  createMapIntentType,
  createObjectIntentType,
  createSetIntentType,
  forEachIntent,
  getIntents,
  isIntent,
  toIntent,
  provider,
} from './intent';
export type {Intent, IntentMap, IntentType, NotIntent} from './intent';
export {VERSION} from './version';
export type {NodeAnimation, Timeline} from './animate';
export {EngineConfigProvider} from './providers/EngineConfigProvider';
export {EngineProvider} from './providers/EngineProvider';

export * from './stylesheets';
export * from './util';

export {
  configureStyle,
  createCustomProperty,
  createKeyframes,
  getAnimationNames,
  StyleCache,
  scheduleStyleIntent,
  cacheStyles,
  lazyStyleIntent,
  lazyGlobalStyleIntent,
  VIEW_CLASS,
  media,
} from './style';
export {
  addressTokens,
  assignConditionalTokens,
  assignTokens,
  createTokens,
  enumerateTokens,
  forEachToken,
  getTokenPath,
  getTokenId,
  getTokenById,
  isToken,
  mergeOverrideIntents,
  resolveToken,
  setStaticToken,
  tokenKeys,
  toStyleDictionaryFormat,
  toW3CTokenFormat,
  useTokenValue,
  useTokenValues,
  usePortalTokenStyles,
  walkTokens,
} from './token';

export * from './view';
export {keyframes} from './stylex/keyframes';

export type {Style} from './style';
export type {Token} from './token';
export type {SafeLinkOptions} from '@stripe-internal/safe-links';

export const animate = _animate;

export {AnimatePresence, AnimatePresenceProvider} from './animate';

declare global {
  /**
   * Disables the runtime CSS-in-JS engine, only use the build-time CSS-in-JS engine.
   *
   * Activate by setting this constant to true in your application's bundler configuration:
   *
   * Example (Webpack, Vite, etc.):
   *   DefinePlugin({ DISABLE_SAIL_RUNTIME_CSS: JSON.stringify(true) })
   *
   * When not set or false, Sail will use the runtime CSS-in-JS engine.
   */
  const DISABLE_SAIL_RUNTIME_CSS: boolean | void;
}
